module.exports = __webpack_public_path__ + "static/media/moderate.503b0dbf.png";